var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharedLineItemProductForm',{attrs:{"line":_vm.line,"auto-save":"","restrict-qty":!!_vm.userSettings.restrictQty,"restrict-product":!!_vm.userSettings.restrictProduct},on:{"save":_vm.save}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddde228c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/basket/LineItemProductForm.vue
// module id = P14B
// module chunks = 1